import {Pipe, PipeTransform} from "@angular/core";
import {ORDER_STATUSES} from "../_maps/order-statuses";

@Pipe({name: "orderStatus"})
export class OrderStatusPipe implements PipeTransform {
  transform(status: string): any {
    return status && ORDER_STATUSES[status];
  }
}
